import { render, staticRenderFns } from "./DialogRoulete.vue?vue&type=template&id=0c7e9539&lang=pug"
import script from "./DialogRoulete.vue?vue&type=script&lang=js"
export * from "./DialogRoulete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports